var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import LmsImportErrorDomainService from "../Domain/LmsImportError/LmsImportError.service";
const BASE_URL = "/aviso/lmsImportError";
export default class LmsImportErrorService {
    static search(search, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const searchResults = yield FetchService.getPagedResponse(BASE_URL + "/search", {
                enrollmentDataQuery: search.enrollmentDataQuery,
                messageQuery: search.messageQuery,
                createdDateFrom: search.createdDateFrom,
                createdDateTo: search.createdDateTo,
                max: options.max,
                offset: options.offset,
                sort: options.sort,
                order: options.order,
            });
            return Object.assign(Object.assign({}, searchResults), { data: searchResults.data.map(LmsImportErrorDomainService.fromJSON) });
        });
    }
    static get(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/get", {
                id,
            }).then(LmsImportErrorDomainService.fromJSON);
        });
    }
}
